import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationDialog, Loading } from '../../../../lib/components';

type Props = {
  open: boolean;
};

export const ApplyingDefaultsDialog: FC<Props> = ({ open }) => {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      open={open}
      variant="neutral"
      width="440px"
      title={t('company:APPLY_DEFAULTS_PENDING_TITLE')}
      contentText={t('company:APPLY_DEFAULTS_PENDING_TEXT')}
      contentComponent={<Loading label={t('company:APPLY_DEFAULTS_PENDING_TITLE')} />}
      hideSaveButton
      hideCancelButton
    />
  );
};
